import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_SERVICE_ORDER_TEMPLATES: createSagaAction('GET_SERVICE_ORDER_TEMPLATES'),
  GET_SERVICE_ORDER_TEMPLATE_ITEMS: createSagaAction('GET_SERVICE_ORDER_TEMPLATE_ITEMS')
}

// Action Creators
export const actions = {
  getServiceOrderTemplates: () => ({
    type: constants.GET_SERVICE_ORDER_TEMPLATES.ACTION
  }),

  getServiceOrderTemplateItems: serviceOrderId => ({
    type: constants.GET_SERVICE_ORDER_TEMPLATE_ITEMS.ACTION,
    serviceOrderId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_SERVICE_ORDER_TEMPLATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_SERVICE_ORDER_TEMPLATES.SUCCESS:
      return {
        ...state,
        serviceOrderTemplates: action.payload
      }
    case constants.GET_SERVICE_ORDER_TEMPLATE_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_SERVICE_ORDER_TEMPLATE_ITEMS.SUCCESS:
      return {
        ...state,
        serviceOrderTemplateItems: action.payload
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/serviceOrderTemplatesActions.js